import { FilterOutlined } from "@ant-design/icons"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"

import { SearchBar } from "../../../components/Input/SearchBar.tsx"
import SelectComponent from "../../../components/Select"
import { STATUS_COLOR_MAP } from "../redux/account-deletion.constants.ts"
import type { DeletionRequestStatus } from "../types/types.ts"

// `STATUS_COLOR_MAP` is a total Record over the status union — deriving the
// filter options from it keeps the two from drifting apart.
const STATUS_VALUES = Object.keys(STATUS_COLOR_MAP) as DeletionRequestStatus[]

interface RequestsFiltersProps {
  status?: DeletionRequestStatus
  q?: string | null
  onSearchChange: (value: string | null) => void
  onStatusChange: (value: DeletionRequestStatus | null) => void
}

export function RequestsFilters({
  status,
  q,
  onSearchChange,
  onStatusChange
}: RequestsFiltersProps) {
  const { t } = useTranslation()

  const statusOptions = STATUS_VALUES.map((s) => ({
    value: s,
    label: t(`accountDeletionRequests.statuses.${s}`)
  }))

  return (
    <Flex wrap="wrap" gap="small">
      <div className={"flex-1 max-md:basis-60 max-md:grow"}>
        <SearchBar
          placeholder={t("accountDeletionRequests.searchPlaceholder")}
          defaultValue={q || ""}
          onSearch={onSearchChange}
        />
      </div>
      <SelectComponent
        placeholder={t("accountDeletionRequests.filterStatus")}
        value={status}
        onChange={(value: unknown) =>
          onStatusChange((value as DeletionRequestStatus) || null)
        }
        className={"max-md:basis-full w-40"}
        suffixIcon={<FilterOutlined />}
        allowClear
        options={statusOptions}
      />
    </Flex>
  )
}
